<template>
    <div class="user-config">
        <!-- 语言设置 -->
        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-s-operation"></i>
                {{ $t('setting.language') }}
            </h4>
            <div class="setting-item">
                <div class="setting-label">
                    <i class="el-icon-edit-outline"></i>
                    <span>{{ $t('setting.languageDesc') }}</span>
                </div>
                <div class="setting-content">
                    <el-select v-model="currentLocale" @change="onLocaleChange" size="small" style="width: 140px">
                        <el-option label="简体中文" value="zh"> </el-option>
                        <el-option label="English" value="en"> </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <!-- 隐私设置 -->
        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-lock"></i>
                {{ $t('userConfig.privacy') }}
            </h4>
            <div class="setting-item">
                <div class="setting-label">
                    <i class="el-icon-user-solid"></i>
                    <span>{{ $t('userConfig.manualApprove') }}</span>
                </div>
                <div class="setting-content">
                    <el-switch v-model="userInfo.isManualApprove" @change="onManualApproveChange"></el-switch>
                </div>
            </div>
        </div>

        <!-- 通知设置 -->
        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-bell"></i>
                {{ $t('userConfig.notification') }}
            </h4>
            <div class="setting-item">
                <div class="setting-label">
                    <i class="el-icon-microphone"></i>
                    <span>{{ $t('userConfig.audioTip') }}</span>
                </div>
                <div class="setting-content">
                    <el-switch v-model="userInfo.isAudioTip" @change="onMessageAudioTip"></el-switch>
                </div>
            </div>
        </div>
        <!-- 字体设置 -->
        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-edit"></i>
                {{ $t('setting.chatFontSize') }}
            </h4>
            <div class="font-preview-area">
                <div class="font-preview-bubble font-preview-other">
                    <span :style="chatFontStylePreview">{{ $t('setting.previewText') }}</span>
                </div>
                <div class="font-preview-bubble font-preview-self">
                    <span :style="chatFontStylePreview">{{ $t('setting.previewText2') }}</span>
                </div>
                <div class="font-preview-bubble font-preview-other">
                    <span :style="chatFontStylePreview">{{ $t('setting.previewText3') }}</span>
                </div>
            </div>
            <div class="setting-item font-slider-item">
                <span class="font-size-label font-small">A</span>
                <el-slider v-model="chatFontSize" :min="12" :max="22" :step="1" style="flex:1;margin:0 16px"
                    @input="onChatFontSizeInput" @change="onChatFontSizeChange"></el-slider>
                <span class="font-size-label font-large">A</span>
                <el-button size="mini" style="margin-left:12px" @click="onResetChatFontSize">
                    {{ $t('setting.resetDefault') }}
                </el-button>
            </div>
        </div>
    </div>
</template>
<script>
import { setLocale } from '@/i18n';

export default {
    name: "userConfig",
    data() {
        return {
            currentLocale: 'zh',
            userInfo: {
                isManualApprove: true,
                isAudioTip: true
            },
            chatFontSize: 14,
            fontSizeReady: false
        }
    },
    created() {
        this.loadChatFontSize();
    },
    computed: {
        chatFontStorageKey() {
            return `chats-web-${this.userStore.userInfo.id}-chatFontSize`;
        },
        chatFontStylePreview() {
            return { fontSize: `${this.chatFontSize}px` };
        }
    },
    methods: {
        init() {
            let mine = this.userStore.userInfo;
            this.userInfo = JSON.parse(JSON.stringify(mine));
            this.currentLocale = this.$i18n.locale;
            this.loadChatFontSize();
        },
        loadChatFontSize() {
            this.fontSizeReady = false;
            const raw = Number(localStorage.getItem(this.chatFontStorageKey));
            this.chatFontSize = (raw >= 12 && raw <= 22) ? raw : 14;
            this.$nextTick(() => {
                this.fontSizeReady = true;
            });
        },
        saveChatFontSize() {
            if (!this.fontSizeReady) return;
            localStorage.setItem(this.chatFontStorageKey, String(this.chatFontSize));
            this.$eventBus.$emit('chatFontSizeChanged', this.chatFontSize);
        },
        onChatFontSizeInput() { this.saveChatFontSize(); },
        onChatFontSizeChange() { this.saveChatFontSize(); },
        onResetChatFontSize() { this.chatFontSize = 14; this.saveChatFontSize(); },
        onLocaleChange(locale) {
            setLocale(locale);
        },
        onManualApproveChange() {
            this.$http({
                url: "/user/manualApprove?enabled=" + this.userInfo.isManualApprove,
                method: 'put'
            }).then(() => {
                this.userStore.loadUser();
            })
        },
        onMessageAudioTip() {
            this.$http({
                url: "/user/audioTip?enabled=" + this.userInfo.isAudioTip,
                method: 'put'
            }).then(() => {
                this.userStore.loadUser();
            })
        }
    }
}
</script>
<style scoped lang="scss">
.user-config {
    padding: 15px;
    background: #fafbfc;
    min-height: 400px;

    // 表单区域
    .form-section {
        background: white;
        border-radius: 8px;
        padding: 15px;
        margin-bottom: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        border: 1px solid #f0f0f0;

        .section-title {
            margin: 0 0 15px 0;
            font-size: var(--im-font-size-larger);
            font-weight: 600;
            display: flex;
            align-items: center;
            gap: 6px;
            padding-bottom: 8px;
            border-bottom: 1px solid #f5f5f5;

            i {
                color: var(--im-color-primary);
                font-size: 16px;
            }
        }
    }

    // 设置项
    .setting-item {
        display: flex;
        align-items: center;
        padding: 12px 0;
        border-bottom: 1px solid #f5f5f5;

        &:last-child {
            border-bottom: none;
        }

        .setting-label {
            flex: 1;
            display: flex;
            align-items: center;
            gap: 8px;
            width: 100px;
            font-weight: 500;
            color: var(--im-text-color-light);
            font-size: var(--im-font-size);

            i {
                color: var(--im-color-primary);
                font-size: var(--im-font-size-large);
            }
        }

        .setting-content {
            flex: 1;
            display: flex;
            justify-content: flex-end;
        }
    }

    .font-preview-area {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 12px;
        background: #f5f7fa;
        border-radius: 6px;
        margin-bottom: 12px;

        .font-preview-bubble {
            display: inline-block;
            padding: 6px 10px;
            border-radius: 10px;
            max-width: 80%;

            &.font-preview-other {
                background: white;
                border: 1px solid #e8edf5;
                align-self: flex-start;
            }

            &.font-preview-self {
                background-color: var(--im-color-primary-light-2);
                align-self: flex-end;

                span { color: white; }
            }
        }
    }

    .font-slider-item {
        display: flex;
        align-items: center;
        padding: 8px 0;

        .font-size-label {
            color: var(--im-text-color-lighter);
            user-select: none;

            &.font-small { font-size: 12px; }
            &.font-large { font-size: 22px; }
        }
    }
}
</style>
